import React from 'react'
import axios from 'axios'
import './admin-application-workflow-modal-area.css'
import SimpleNotification from '../../DanitComponents/Notifications/SimpleNotification';
import LooksLikeYouAreDonePopup from '../../WorfklowCardModal2023/LooksLikeYouAreDonePopup/LooksLikeYouAreDonePopup';
import { baseUrl } from '../../assets/Animations';
import { getRequestHeaders } from '../../api';
import { MdClose } from 'react-icons/md';
import ApplicationModalArea2024 from './ApplicationModalArea2024/ApplicationModalArea2024';
import ApplicationInfoGutter from './ApplicationInfoGutter/ApplicationInfoGutter';
import NoteAreaFall2023 from '../../StudentOnboardingCardModalFall2023/NoteAreaFall2023/NoteAreaFall2023';


const AdminApplicationWorkflowModalArea2024 = ({workflow, setOpenWorkflowModal2024, createNoteFunc, userData, updateItem, deleteItem, setCongratsModal}) => {
    const [copyConfirmationPopup, setCopyConfirmationPopup] = React.useState(false)
    //const [areYouDonePopup, setAreYouDonePopup] = React.useState(false)


    const saveAndCloseTask = () => {
        axios.put(`${baseUrl}/teacher-onboarding/${workflow.todoId}`, workflow, getRequestHeaders())
        .then((res) => {
            updateItem(res.data, 'todoId')
            setOpenWorkflowModal2024(false)
        })
        .catch((err) => console.log(err))
    }

    // const deleteAndCloseTask = () => {
    //     axios.delete(`${baseUrl}/teacher-onboarding/${workflow.todoId}`, getRequestHeaders())
    //     .then((res) => {
    //         deleteItem(res.data, 'todoId')
    //         setOpenWorkflowModal2024(false)
    //     })
    //     .catch((err) => console.log(err))
    // }

    const checkForUnfinishedSubtasksAndThenProceed = () => {
        if(workflow.whichList === 'waitlist') {
            setOpenWorkflowModal2024(false)
        } else {
            saveAndCloseTask()
        }
        //THE WORKFLOW COMPLETE POPUP
        // if(workflow.whichList !== 'waitlist') {
        //     workflow?.todoSubtasks.filter((sub) => !sub.subtaskCompleted && sub).length > 0 ? saveAndCloseTask() : setAreYouDonePopup(true)
        // }
    }
    const simpleNotificationStyleObj = {
    
        backgroundColor: 'bg-green-100',
        titleColor: 'text-green-800',
        subtitleColor: 'text-green-800'
    
    }

    return (
        <div className='student-onboarding-card-modal-fall-2023__wrapper' id='student-onboarding-card-modal-fall-2023__wrapper' onClick={(e) => e.target.id === 'student-onboarding-card-modal-fall-2023__wrapper' && checkForUnfinishedSubtasksAndThenProceed()}>
            {copyConfirmationPopup && <SimpleNotification style={simpleNotificationStyleObj} title={'Link Copied to Clipboard'} action={setCopyConfirmationPopup} show={copyConfirmationPopup} />}
            {/* {areYouDonePopup && <LooksLikeYouAreDonePopup saveAndCloseTask={saveAndCloseTask} deleteAndCloseTask={deleteAndCloseTask} />} */}
            <div className='student-onboarding-card-modal-fall-2023__closing-x__gutter'>
                <div className='student-onboarding-card-modal-fall-2023__closing-x__wrapper'>
                    <MdClose onClick={() => checkForUnfinishedSubtasksAndThenProceed()} color='#334155' size={24}/>
                </div>
            </div>
            <div className='student-onboarding-card-modal-fall-2023__main-card'>
                <ApplicationModalArea2024 
                    workflow={workflow} 
                    setOpenWorkflowModal2024={setOpenWorkflowModal2024}
                    updateItem={updateItem}
                    deleteItem={deleteItem}
                    setCongratsModal={setCongratsModal}
                />
            </div>
            <div className='student-onboarding-card-modal-fall-2023__gutter-1'>
                {/* <FamilyInfoGutter modalInfo={studentOnboardingModal} setModalInfo={setStudentOnboardingModal} setCopyConfirmationPopup={setCopyConfirmationPopup} /> */}
                <ApplicationInfoGutter applicationId={workflow.applicationId} />
            </div>
            <div className='student-onboarding-card-modal-fall-2023__notes-area'>
                <NoteAreaFall2023
                    modalInfo={{id: workflow.applicationId, type: 'applicationId'}}  
                    userData={userData} 
                    createNoteFunc={createNoteFunc} 
                    school={workflow.whichSchool}
                />
            </div>
        </div>
    );
    }
export default AdminApplicationWorkflowModalArea2024;